import React from "react";

const ShimmerBlock = ({ className = "" }) => (
  <div
    className={`
      bg-slate-200 
      animate-shimmer 
      bg-[linear-gradient(90deg,#ececec,#f5f5f5,#ececec)] 
      bg-[length:1000px_100%] 
      rounded 
      ${className}
    `}
  />
);

const ArticleTableRowSkeleton: React.FC = () => (
  <div className="grid grid-cols-12 gap-4 py-4 px-6 border-b border-slate-100 last:border-b-0 items-center">
    {/* Article Title column */}
    <div className="col-span-8 flex items-center space-x-3">
      <ShimmerBlock className="w-10 h-10 rounded-lg flex-shrink-0" />
      <div className="flex-1">
        <ShimmerBlock className="h-4 w-48" />
      </div>
    </div>

    {/* Updated At column */}
    <div className="col-span-2">
      <ShimmerBlock className="h-4 w-24" />
    </div>

    {/* Actions column */}
    <div className="col-span-2 flex justify-end space-x-2">
      <ShimmerBlock className="w-8 h-8 rounded-lg" />
      <ShimmerBlock className="w-8 h-8 rounded-lg" />
    </div>
  </div>
);

export const ArticleTableSkeleton: React.FC = () => {
  const skeletonRows = Array.from({ length: 5 });

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
      {/* Table Header Skeleton */}
      <div className="hidden md:grid grid-cols-12 gap-4 px-6 py-4 border-b border-slate-100 bg-slate-50/50">
        <div className="col-span-8"><ShimmerBlock className="h-4 w-24" /></div>
        <div className="col-span-2"><ShimmerBlock className="h-4 w-20" /></div>
        <div className="col-span-2 text-right flex justify-end"><ShimmerBlock className="h-4 w-16" /></div>
      </div>
      
      {/* Table Body Skeleton */}
      <div className="divide-y divide-slate-100">
        {skeletonRows.map((_, index) => (
          <ArticleTableRowSkeleton key={index} />
        ))}
      </div>

      {/* Footer Skeleton */}
      <div className="px-6 py-4 flex justify-between items-center border-t border-slate-100 bg-slate-50/30">
        <ShimmerBlock className="h-4 w-32" />
        <div className="flex space-x-4">
          <ShimmerBlock className="h-8 w-16 rounded-lg" />
          <ShimmerBlock className="h-8 w-24 rounded-lg" />
        </div>
      </div>
    </div>
  );
};
